export default (options = {}) => ({
  chart: {
    type: 'scatter',
    zoomType: 'xy',
    spacingTop: 15,
    ...(options.chartOptions || {}),
  },
  xAxis: {
    allowDecimals: false,
    crosshair: {
      enabled: true,
      color: '#848ea1',
    },
    minRange: 7,
    title: {
      text: null,
    },
    ...(options.xAxisOptions || {}),
  },
  yAxis: {
    allowDecimals: false,
    crosshair: {
      enabled: true,
      color: '#848ea1',
    },
    lineWidth: 1,
    minRange: 1,
    title: {
      text: null,
    },
    ...(options.yAxisOptions || {}),
  },
  tooltip: {
    padding: 0,
    border: 0,
    ...(options.tooltipOptions || {}),
  },
  legend: {
    enabled: false,
  },
  lang: {
    noData: '<h2 class="text-lg m-b">No data to display</h2>',
  },
  noData: {
    position: {
      y: 50,
    },
  },
  plotOptions: {
    series: {
      lineWidth: 0,
      marker: {
        enabled: true,
      },
      states: {
        hover: {
          enabled: true,
        },
      },
      ...(options.plotOptionsSeries || {}),
    },
    scatter: {
      dataLabels: {
        enabled: true,
      },
      tooltip: {
        headerFormat: '<b>{series.name}</b><br>',
        pointFormat: '{point.x} cm, {point.y} kg',
        clusterFormat: 'Clustered points: {point.clusterPointsAmount}',
      },
      marker: {
        radius: 4,
        fillColor: '#212531',
      },
      cluster: {
        enabled: true,
        allowOverlap: false,
        minimumClusterSize: 2,
        layoutAlgorithm: {
          type: 'optimalizedKmeans',
          distance: '5%',
        },
        dataLabels: {
          overflow: true,
          crop: false,
          style: {
            fontSize: '9px',
          },
          y: -2,
        },
        marker: {
          lineColor: 'rgba(0, 0, 0, 0.1)',
        },
        zones: [{
          from: 1,
          to: 2,
          marker: {
            fillColor: 'rgba(33, 37, 49, 0.2)',
            radius: 12,
          },
        }, {
          from: 3,
          to: 5,
          marker: {
            fillColor: 'rgba(33, 37, 49, 0.3)',
            radius: 13,
          },
        }, {
          from: 6,
          to: 9,
          marker: {
            fillColor: 'rgba(33, 37, 49, 0.4)',
            radius: 15,
          },
        }, {
          from: 10,
          to: 100,
          marker: {
            fillColor: 'rgba(33, 37, 49, 0.5)',
            radius: 18,
          },
        }],
        ...(options.clusterOptions || {}),
      },
      ...(options.plotOptionsScatter || {}),
    },
  },

  ...(options.restOptions || {}),
});
